const mapping: Record<string, string> = {
  id: 'l=>l.Id',
  name: 'l=>l.Name',
}

export const mapSortPDFDefinitionsParam = (key: string) => mapping[key]
